import React, { Component } from 'react';

export class ServicePage extends Component {
    state = { 
        info: {}
    }

    componentDidMount = () => {
        const {info} = this.props.location.state;
        this.setState({info});
        document.title = 'AGT - ' + info.title;
    }

    styles = {
        header: {
            fontSize: 60,
            color: '#EE3124'
        },

        body:{
            fontSize: 20
        }
    }

    render() { 
        return ( 
            <React.Fragment>
            <div class="container border border-grey">
                <div class="text-center mt-4">
                    <h1 class="heading" style={this.styles.header}>{this.state.info['title']}</h1>
                </div>
                <div class="text-left ml-5">
                    <p class="subheading" style={this.styles.body}>{this.state.info['body']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body1']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body2']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body3']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body4']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body5']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body6']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body7']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body8']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body9']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body10']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body11']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body12']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body13']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body14']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body15']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body16']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body17']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body18']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body19']}</p>
		<p class="subheading" style={this.styles.body}>{this.state.info['body20']}</p>
                </div>
            </div>
            </React.Fragment>
        );
    }
}
 
